module.exports = __webpack_public_path__ + "static/media/HL10.6ab7d950.jpg";